module.exports = __webpack_public_path__ + "static/media/Fresh_Pack_Blue_30.b313953b.png";